import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";

const EMPTY = { current: "", next: "", confirm: "" };

export const ChangePasswordDialog = ({ open, onClose }) => {
  const [f, setF] = useState(EMPTY);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (open) setF(EMPTY);
  }, [open]);

  const set = (k) => (e) => setF((x) => ({ ...x, [k]: e.target.value }));

  const save = async () => {
    if (f.next.length < 6) return toast.error("New password must be at least 6 characters");
    if (f.next !== f.confirm) return toast.error("New passwords do not match");
    setBusy(true);
    try {
      await api.post("/auth/change-password", { current_password: f.current, new_password: f.next });
      toast.success("Password changed");
      onClose();
    } catch (e) {
      toast.error(errMsg(e));
    } finally {
      setBusy(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="sm:max-w-sm" data-testid="change-password-dialog">
        <DialogHeader>
          <DialogTitle className="text-2xl text-[#24474A]">Change password</DialogTitle>
          <DialogDescription>Use at least 6 characters.</DialogDescription>
        </DialogHeader>
        <div className="space-y-3">
          <div className="space-y-1.5"><Label>Current password</Label><Input type="password" value={f.current} onChange={set("current")} data-testid="current-password-input" /></div>
          <div className="space-y-1.5"><Label>New password</Label><Input type="password" value={f.next} onChange={set("next")} data-testid="new-password-input" /></div>
          <div className="space-y-1.5"><Label>Confirm new password</Label><Input type="password" value={f.confirm} onChange={set("confirm")} data-testid="confirm-password-input" /></div>
        </div>
        <div className="flex justify-end gap-2 pt-2">
          <Button variant="ghost" className="rounded-full" onClick={onClose}>Cancel</Button>
          <Button className="rounded-full" onClick={save} disabled={busy || !f.current} data-testid="change-password-save-btn">Update password</Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
